import React from 'react';
import { styled } from 'linaria/react';

export const CenterBlock = styled('div')`
  text-align: center;
  h1,
  h2,
  h3,
  h4,
  p {
    text-align: center !important;
  }
  * {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }
`;

const Center = ({ children }) => <CenterBlock>{children}</CenterBlock>;

export default Center;
